// extracted by mini-css-extract-plugin
export default {"comparison_modal":"ComparisonModal_comparison_modal__daDbC","wrapper":"ComparisonModal_wrapper__ajYiI","group_wraper":"ComparisonModal_group_wraper__x5qvS"};